export enum DraggableKinds {
  EDIT_FORM_TABLE_ROW_HANDLE = 'EDIT_FORM_TABLE_ROW_HANDLE',
}
